import AmountRow from '../AmountRow';

interface IAmountHeader {
  data: [string, string, string, string];
}

const AmountHeader = ({ data }: IAmountHeader) => {
  return <AmountRow data={data} isHeader />;
};
export default AmountHeader;
